import { TelekitsListSearchComponent } from './TelekitsListSearchComponent'
import { TelekitsListToolbar } from './TelekitsListToolbar'

export const TelekitsListHeader = () => {
  return (
    <div className='card-header border-0 pt-6'>
      <TelekitsListSearchComponent actions={<TelekitsListToolbar />} />
    </div>
  )
}
